var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardLayout',_vm._g(_vm._b({attrs:{"item":_vm.item,"compact":""}},'CardLayout',_vm.$attrs,false),_vm.$listeners),[_c('IxRes',[_vm._v("masterData.crops.quality."+_vm._s(_vm.item.id)+"_name")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }